module.exports = __webpack_public_path__ + "static/media/logo-televisa-black-m.9a59eb3d.svg";